import api from "actions/api.js"


export function getPerson(id) {
    return api(`person/${id}`)
}

export function putPerson(person) {
    return api(`person/${person.id}`,
        {
            method: "PUT",
            body: JSON.stringify(person)
        })
}


/** WEBPACK FOOTER **
 ** ./src/actions/profile/person/api.js
 **/